import Model from './model'

export default
class SaveAction {

  constructor(model: Model) {
    this.model = model
    this.asJSON = undefined
    this.asString = undefined
  }

  execute(opts = {}) {

    return this.validate()
      .then(() => this.prepareData())
      .then(() => this.checkNeedsSave())
      .then(() => this.save(opts))

  }

  validate() {
    return new Promise((resolve, reject) => {
      if (!this.model.store) {
        // eslint-disable-next-line max-len
        reject(new Error(`The model of type "${this.constructor.name}" has no store property. Each model that shouls be saved NEEDS a store!`))
      }

      if (!this.model.getJSON) {
        // eslint-disable-next-line max-len
        reject(new Error(`Trying to save the Model "${this.constructor.name}" but getJSON is missing on this model`))
      }

      resolve(true)
    })
  }

  prepareData() {
    this.asJSON = this.model.getJSON()
    this.asString = JSON.stringify(this.asJSON)
  }

  checkNeedsSave() {
    // Check whether the data did change. Only save if it did
    this.didChange = this.asString !== this.model.previouslySavedJSON
  }

  save(opts) {

    const { model } = this

    if (!this.didChange) {
      // if no change, return the currently running save promise...
      if (model.saving) {
        return model.saving
      }
      // or just the current data as a promise
      return Promise.resolve(this.asJSON)
    }

    // sequencialize new save calls
    const savePromise = model.saving || Promise.resolve(true)

    return savePromise.then(() => {
      model.saving = model.store.save(model.id, model, opts)
        .then((result) => this.handleSaveSuccess(result))
        .catch((err) => this.handleSaveError(err))
      return model.saving
    })
  }

  handleSaveSuccess(result) {

    this.model.previouslySavedJSON = this.asString
    // this.model.set(result.body)
    this.model.saving = null
    return result

  }

  handleSaveError(err) {
    this.model.saving = null
    throw err
  }

}



// WEBPACK FOOTER //
// ./src/shared/SaveAction.js